module.exports = __webpack_public_path__ + "img/Base-Size-Reference3@2x.7cbc7e72.jpg";